import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://mdftijdjckugrdouslni.supabase.co';
const SUPABASE_KEY = 'sb_publishable_itbwTGCKUHx5Kg_FuYfT8g_iiZsVnUS';

// Creamos una única instancia para evitar el error de Navigator LockManager
export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY, {
    auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true
    }
});
